import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/app/router'
import { ToastProvider } from '@/components/ui/Toast'
import { initialiseAppCheck } from '@/firebase/app'
import { registerServiceWorker } from '@/pwa/registerServiceWorker'
import './styles/index.css'

/**
 * Boot order matters:
 *  1. App Check first, so the very first callable already carries a token.
 *  2. React.
 *  3. The service worker last, and only on admin routes.
 *
 * Firebase Analytics is deliberately NOT initialised here. It is loaded on
 * demand, only after analytics consent — see src/features/analytics.
 */

initialiseAppCheck()

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

/**
 * `AuthProvider` is deliberately NOT here. Mounting it at the root would make
 * the Firebase Auth and Firestore SDKs a static import of the entry chunk,
 * and every diner opening a booking page would download ~467 kB they never
 * use. It lives inside the lazily-loaded dashboard layouts instead — see
 * src/app/router.tsx.
 */
createRoot(container).render(
  <StrictMode>
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  </StrictMode>,
)

registerServiceWorker()
